var Theme = {};

(function ($, Drupal, drupalSettings) {
  'use strict';

  Drupal.Theme = {};

  /**
   * Constructeur
   */
  Theme.Common = function () {
    // Éléments
    this.elements = {
      htmlBody: $('html, body'),
      body: $('body'),
      page: $('#page'),
    };

    this.elements.externalLinks = this.elements.page.find('a[href^="http"]');
    this.elements.openInNewWindowLinks = this.elements.page.find('a[href$=".pdf"]');

    // Variables
    this.menuScrollOffset = 110;
    this.langcode = drupalSettings.path.currentLanguage || 'fr';

    return this;
  };

  /**
   * Méthodes
   */
  Theme.Common.prototype = {
    load: function (className, options) {
      if (Theme[className] !== undefined) {
        return new Theme[className](this, options);
      } else {
        console.error('Class "Theme.' + className + '" not found.');
      }
    },
    autoload: function (options) {
      var self = this;

      if (options !== undefined) {
        $.each(options, function (className, condition) {
          if (self.elements.body.is(condition)) {
            return self.load(className).init();
          }
        });

      } else {
        console.error('Options is undefined.');
      }
    },

    /**
     * Init common
     */
    init: function () {
      this.cookieTarteAuCitronHandler();
      this.externalLinksHandler();
      this.openInNewWindowHandler();
      this.anchorLinksHandler();
    },

    /**
     * Gestionnaire de CookieNotice
     */
    cookieTarteAuCitronHandler: function () {
      var gtmGoogle = drupalSettings.GTMcookie;
      var uaGoogle = drupalSettings.GTAGcookie;
      tarteaucitron.init({
        "hashtag": "#tarteaucitron",
        "cookieName": "tarteaucitron",
        "orientation": "middle",
        "showAlertSmall": true,
        "showIcon": false,
        "cookieslist": false,
        "adblocker": false,
        "AcceptAllCta": true,
        "highPrivacy": true,
        "handleBrowserDNTRequest": false,
        "removeCredit": true,
        "moreInfoLink": true,
        "useExternalCss": false,
        "bodyPosition": "bottom",
        "groupServices": false,
        "showDetailsOnClick": true,
        //"serviceDefaultState": "wait",
        "iconPosition": "BottomRight",
        "DenyAllCta" : true,
        "useExternalJs": false,
        "readmoreLink": "/mentions-legales",
        "mandatory": true,
        "mandatoryCta": true,
        "googleConsentMode": true,
        "partnersList": false
      });

      (tarteaucitron.job = tarteaucitron.job || []).push('gcmadstorage');
      (tarteaucitron.job = tarteaucitron.job || []).push('gcmanalyticsstorage');
      (tarteaucitron.job = tarteaucitron.job || []).push('gcmfunctionality');
      (tarteaucitron.job = tarteaucitron.job || []).push('gcmadsuserdata');
      (tarteaucitron.job = tarteaucitron.job || []).push('gcmsecurity');
      (tarteaucitron.job = tarteaucitron.job || []).push('gcmpersonalization');

      if (gtmGoogle) {
        tarteaucitron.user.googletagmanagerId = gtmGoogle;
        (tarteaucitron.job = tarteaucitron.job || []).push('googletagmanager');
      }
      if (uaGoogle) {
        tarteaucitron.user.gtagUa = uaGoogle;
        (tarteaucitron.job = tarteaucitron.job || []).push('gtag');
      }
      (tarteaucitron.job = tarteaucitron.job || []).push('youtube');
    },

    /**
     * Gestionnaire des liens externes
     */
    externalLinksHandler: function () {
      if (this.elements.externalLinks.length) {
        this.elements.externalLinks.each(function (i, link) {
          link = $(link);

          if (link.attr('href').indexOf(window.location.host) === -1) {
            link.attr('target', '_blank');
          }
        });
      }
    },

    /**
     * Gestionnaire pour l'ouverture de lien dans un nouvel onglet
     */
    openInNewWindowHandler: function () {
      if (this.elements.openInNewWindowLinks.length) {
        this.elements.openInNewWindowLinks.on('click', function (event) {
          event.preventDefault();
          window.open($(event.currentTarget).attr('href'));
        });
      }
    },

    /**
     * Gestionnaire des ancres
     */
    anchorLinksHandler: function () {
      var self = this;

      self.elements.page.on('click', 'a[href*="#"]:not([href="#"])', function (event) {
        if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

          if (target.length) {
            event.preventDefault();

            self.scrollTop(target.offset().top);
          }
        }
      });
    },

    /**
     * Scroll top
     *
     * @param offset
     * @param speed
     */
    scrollTop: function (offset, speed) {
      speed = speed || 500;

      this.elements.htmlBody.animate({
        scrollTop: (offset - this.menuScrollOffset)
      }, speed);

      return this;
    },

  };

  /**
   * Load Themes
   * @type {{attach: attach, detach: detach}}
   */
  Drupal.behaviors.drupTheme = {
    attach: function (context) {

      if (context.body !== undefined) {
        Drupal.Theme = new Theme.Common();
        Drupal.Theme.init();
        Drupal.Theme.load('all').init();
        Drupal.Theme.load('all').load();

        // Drupal.Theme.autoload({
        //     front: '.is-front'
        // });
      } else {
        context = $(context);

        if (context.length) {
          if (context.is('.block-view-display-list-news')) {
            var all = Drupal.Theme.load('all');
            all.customFormHandler();
          }
        }
      }
    }
  };

}(jQuery, Drupal, drupalSettings));

